import { __awaiter } from "tslib";
import { PublicChannelVideos } from '@wix/wix-vod-api-site-based/dist/src/public/services/channel-videos/channel-videos';
import { toError } from '../../parsers/to-error';
import { parseVideoItem } from '../../parsers/video-item';
export class PublicChannelVideosService {
    constructor(httpClient, baseUrl) {
        this.publicChannelVideos = new PublicChannelVideos(httpClient, baseUrl);
    }
    parseListChannelResponse(response, sort) {
        return Object.assign(Object.assign({}, response), { data: _.map(response.data.items, parseVideoItem), sort, paging: {
                size: response.data.items.length,
                cursor: response.data.cursor,
            } });
    }
    parseChannelVideoResponse(response) {
        return Object.assign(Object.assign({}, response), { data: parseVideoItem(response.data) });
    }
    listChannelVideos({ channelId, query, tag, category, mediaType, sort, paging, hydratedChannelVideos, templateMetaSiteId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = hydratedChannelVideos ||
                    (yield this.publicChannelVideos.getList({
                        channelId,
                        query,
                        tag,
                        category,
                        mediaType,
                        sort,
                        paging,
                        templateMetaSiteId,
                    }));
                return this.parseListChannelResponse(response, sort);
            }
            catch (error) {
                return toError(error);
            }
        });
    }
    getChannelVideoById(channelId, videoId, { hydratedVideo, templateMetaSiteId, } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = hydratedVideo ||
                    (yield this.publicChannelVideos.getChannelVideoById(channelId, videoId, {
                        params: {
                            metaSiteId: templateMetaSiteId,
                        },
                    }));
                return this.parseChannelVideoResponse(response);
            }
            catch (error) {
                return toError(error);
            }
        });
    }
}
//# sourceMappingURL=channel-videos.js.map